/**
 * Module: `queries/conversation-cache-policy.ts` — client library utilities.
 * @remarks See exports; keep imports from concrete files when possible.
 */

/**
 * DEV instrumentation and documentation for allowed cache mutations.
 * Targeted TanStack DB updates live in `conversation-content.ts` and `conversation-questions.ts`.
 */

let devConversationContentNetworkFetchCount = 0;

/** DEV-only: count of Dust conversation snapshot fetches (for tuning refetch behavior). */
export function recordConversationContentNetworkFetch(
  _conversationId: string
): void {
  if (import.meta.env.DEV) {
    devConversationContentNetworkFetchCount += 1;
  }
}

export function getDevConversationContentNetworkFetchCount(): number {
  return devConversationContentNetworkFetchCount;
}

export function resetDevConversationContentNetworkFetchCount(): void {
  devConversationContentNetworkFetchCount = 0;
}
